import { t } from "@web-monorepo/i18n/macro";
import { getImageSrc } from "@web-monorepo/static-assets";
import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { ExpectationsSlide } from "src/pods/conundrums/components/ExpectationsSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";

const civicServantsImage = getImageSrc("toolkit/src/pods/conundrums/assets/civicServantsIntro@2x.jpg");
const doctorImage = getImageSrc("toolkit/src/pods/conundrums/assets/doctor@2x.png");
const firefighterImage = getImageSrc("toolkit/src/pods/conundrums/assets/firefighter@2x.png");
const mojoIsland = getImageSrc("toolkit/src/pods/conundrums/assets/mojoIsland@2x.jpg");
const teacherImage = getImageSrc("toolkit/src/pods/conundrums/assets/teacher@2x.png");

const questionOptions = {
  doctors: {
    id: "doctors",
    option: () => t`Doctors`,
    icon: doctorImage,
  },
  firefighters: {
    id: "firefighters",
    option: () => t`Firefighters`,
    icon: firefighterImage,
  },
  teachers: {
    id: "teachers",
    option: () => t`Teachers`,
    icon: teacherImage,
  },
};

const slide2Options = [questionOptions.doctors, questionOptions.firefighters];
const slide3Options = [questionOptions.doctors, questionOptions.firefighters, questionOptions.teachers];
const getTitle = () => t`Civic Servants`;
const getDescription = () => t`Mojo is the mayor of Monster Island, and must decide:`;
const getQuestionText = () => t`Who should be paid the most money? Why?`;
const getSentenceStarter = () => t`_____ should be paid the most because...`;

const activities: Slide[] = [
  IntroSlide(getTitle, getDescription, getQuestionText, civicServantsImage),
  ExpectationsSlide(),
  DescriptionSlide(() => t`Mojo is the mayor of Monster Island and needs to make an important decision!`, mojoIsland),
  OptionsSlide(
    getQuestionText,
    slide2Options,
    [{ id: "teachers", option: () => t`Teachers`, icon: teacherImage }],
    getSentenceStarter,
  ),
  OptionsSlide(getQuestionText, slide3Options, undefined, getSentenceStarter),
  PairShareSlide(
    () =>
      t`Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?`,
  ),
  ShareToStorySlide(
    () => t`Congrats on completing this Conundrum!`,
    () => t`Now that was an interesting question indeed.`,
    "https://static.classdojo.com/img/civilServantsShare.png",
    () => t`Great discussion!`,
  ),
];

export default activities;
